<template>
  <div>
    <section id="error-logs-index__page" class="mb-10">
      <page-header
        header-col="5"
        :breadcrumbs="breadcrumbs"
        :title="$dictionary.app.errorLogs.index.title"
      >
        <v-col
          cols="12"
          md="8"
          lg="7"
          class="d-flex align-center justify-end flex-wrap flex-lg-nowrap"
        >
          <debounce-search-text-field
            prop-to-search="source"
            id="search-error-logs-btn"
            :lazy-search="fetchErrorLogs"
            :no-of-records="errorsParams.per_page || 10"
            :sort-by="sortConfig.sortBy"
            :sort-order="sortConfig.sortOrder"
            @search-value="searchErrors = $event"
            placeholder="Search Error logs..."
          />
        </v-col>
      </page-header>
      <v-row class="d-flex justify-center pt-3" no-gutters>
        <v-col cols="12" class="pt-3">
          <error-logs-table
            :data="errorLogsList"
            :is-loading="isLoading"
            @get-records="fetchErrorLogs"
          />
        </v-col>
      </v-row>
    </section>
  </div>
</template>

<script>
import PageHeader from "@/components/shared/PageHeader.vue";
import ErrorLogsTable from "@/components/tables/ErrorLogsTable.vue";
import DebounceSearchTextField from "@/components/shared/DebounceSearchTextField.vue";

import { errorLogs } from "@/services/errorLogs";
import { SharedUtilsMixin, TitleMixin } from "@/mixins";
import { hasProp } from "@/utils/common.utils";

/**
 * Error logs index page
 */
export default {
  name: "ErrorLogs",
  /**
  |--------------------------------------------------
  | Title of the page
  |--------------------------------------------------
  */
  title: "Error Logs",
  /**
  |--------------------------------------------------
  | Mixins
  |--------------------------------------------------
  */
  mixins: [TitleMixin, SharedUtilsMixin],
  /**
  |--------------------------------------------------
  | Components
  |--------------------------------------------------
  */
  components: { PageHeader, ErrorLogsTable, DebounceSearchTextField },
  /**
  |--------------------------------------------------
  | Data properties
  |--------------------------------------------------
  */
  data() {
    return {
      errorsParams: {},
      isLoading: false,
      errorLogsList: [],
      searchErrors: "",
    };
  },
  /**
|--------------------------------------------------
| Computed properties
|--------------------------------------------------
*/
  computed: {
    /**
     * View breadcrumbs
     * @type {Array}
     */
    breadcrumbs() {
      return [
        {
          title: this.$dictionary.app.errorLogs.index.title,
          type: this.$appConfig.breadcrumbs.types.route,
        },
      ];
    },
    sortConfig() {
      return this.getSortConfig("errorsParams", "source");
    },
  },
  /**
  |--------------------------------------------------
  | Methods
  |--------------------------------------------------
  */
  methods: {
    /**
     * Fetches list of error logs in inboxaware
     */
    async fetchErrorLogs(params = this.errorsParams) {
      try {
        const prop = `q[source_cont]`;
        this.errorsParams = params;

        if (!hasProp(this.errorsParams, prop) && this.searchErrors) {
          this.errorsParams[prop] = this.searchErrors;
        }
        this.isLoading = true;
        const { data } = await errorLogs(this.errorsParams);

        this.errorLogsList = data;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
